export const tariffChargeTypes = ['OC', 'DC', 'FC'] as const;
export type ChargeType = typeof tariffChargeTypes[number];
